var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1815_3219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60742 20.3613L11.5232 25.2441L10.8084 25.9394L5.89258 21.0566L6.60742 20.3613Z",
    fill: "#4726D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.815 25.928L4.84392 27.491C4.45485 27.5974 4.10229 27.2276 4.21614 26.8406L5.90083 21.0645L6.73783 21.8752L5.46829 26.2402L10.0306 25.0433L10.815 25.928Z",
    fill: "#4726D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4886 5.56787L26.6229 9.80392L26.9706 10.1602L26.6132 10.509L11.4828 25.276L10.7776 24.5708L25.5604 10.143L22.1226 6.62064L7.29703 21.0902L6.5918 20.3849L21.7835 5.55812L22.1397 5.21045L22.4886 5.56787Z",
    fill: "#4726D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1416 5.22229C22.8224 4.55781 23.7089 4.23219 24.5917 4.24293C25.4726 4.25364 26.3494 4.59948 27.014 5.27785L27.015 5.27691L27.015 5.27693L27.0189 5.2828C27.6834 5.96361 28.009 6.8501 27.9983 7.73291C27.9876 8.61381 27.6417 9.4905 26.9633 10.1552L26.9643 10.1562L26.9643 10.1562L26.9633 10.1552L26.9584 10.1601L26.6121 9.80399L26.2572 9.44914L26.2573 9.44913L26.2631 9.44521C26.7476 8.97238 26.9946 8.34813 27.0022 7.72117C27.0098 7.09613 26.7792 6.46769 26.3088 5.98309L26.308 5.98397L26.3079 5.98395L26.304 5.97809C25.8312 5.49363 25.207 5.24665 24.58 5.23905C23.9528 5.23143 23.3222 5.46353 22.8369 5.93715L22.1416 5.22229V5.22229Z",
    fill: "#4726D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1815_3219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.a5222bf2.svg";
export { ForwardRef as ReactComponent };